<template>
<v-app>
<v-main
    v-if="organization_account != null"
>

   <m-make-payment-app-bar
        :value="organization_label"
        :banner_branding="banner_branding"
    />

    <v-container>
        <div
            style="margin-left: 15px; margin-right: 15px"
        >

        <h2
            style="text-align: center; margin-top: 30px; margin-bottom: 30px"
        >
            {{organization_label}} Text Messaging Privacy Policy Addendum
        </h2>
        <p
            style="margin-top: 15px"
        >
            <b>Introduction</b>
        </p>  

        <p
            style="margin-top: 10px"
        >
            This Text Message Text Messaging Privacy Policy Addendum is a legal agreement between {{organization_label}} ("{{organization_label}}", "Company", "we", "our", or "us") and you that supplements our Privacy Policy, 
            available from <a :href="underlying_privacy_policy_url" target="_blank">{{underlying_privacy_policy_url}}</a>, by specifically describing our privacy practices in connection with your use of our SMS messaging program (the "Platform"). 
            In the event of any conflict between the Text Messaging Privacy Policy Addendum and the Privacy Policy in relation to the subject matter provided herein, the Text Messaging Privacy Policy Addendum shall take precedent. 
        <p>
        <p>
            <b>Terms</b>
        </p>    
        <p>
            Under no circumstances will {{organization_label}} sell or share your name, mobile telephone number, or other personal information with third-parties or affiliates for marketing or promotional purposes.
        </p>
        <p>
            Under no circumstances will {{organization_label}} purchase or use your name and mobile telephone number collected from third parties.
        </p>

        <p>
            You can cancel the SMS service at any time. Just text "STOP" to the number or short code that sent you the message. 
            After you send the SMS message "STOP" to us, we will send you an SMS message to confirm that you have been unsubscribed. 
            After this, you will no longer receive SMS messages from us. If you want to join again, just sign up as you did the first time 
            and we will start sending SMS messages to you again.
        </p>
        <p>
            Carriers are not liable for delayed or undelivered messages.
        </p>
        <p>
            You will receive messages with info, promotions, and offers to the number(s) you have provided, including use of an automated system.
        </p>
        <p>
            Message frequency varies.
        </p>
        <p>
            As always, message and data rates may apply for any messages sent to you from us and to us from you.  If you have any questions about your text plan or data plan, it is best to contact your wireless provider.
        </p>

         <p>
            If you have any questions regarding our terms and conditions, please <a :href="tc_addendum_url" target="_blank">click here to read our terms and conditions</a>.
        </p>

        <p>
            <b>Contact Us</b>
        </p>

        <p>
            If you have any questions or feedback relating to these Text Messaging Privacy Policy Addendum, or need any help, please contact us via email at <a :href="'mailto:'+support_email">{{support_email}}</a>.
        </p>

        <p>
            You may also text HELP for help at any time.
        </p>

        </div>
    </v-container>

</v-main>


  <m-global-spinner/>
  <m-global-snackbar/>
  <m-global-alert/>
  <m-global-confirm/>
  <m-global-prompt/>

</v-app>
</template>

<script>

export default {

    data() {
        return {
            banner_branding: null,
            organization_account: null,
            support_email: null,
            underlying_terms_and_conditions_url: null,
            underlying_privacy_policy_url: null,
        }
    },

    mounted () {
        this.loadProfile();
    },   

    methods: {
      loadProfile()
      {
            this.$rc.rest({
                'spinner': true,
                'endpoint': 'PUT: /api/v1/opt-in-form/legal/text-addendum-profile',
            
                'params' : {
                        'organization_id': this.$route.params.organization_id
                    },
            
                'on_success': (data) => {
                        this.banner_branding = data.banner_branding;
                        this.organization_account = data.organization_account;
                        this.support_email = data.support_email;
                        this.underlying_terms_and_conditions_url = data.underlying_terms_and_conditions_url;
                        this.underlying_privacy_policy_url = data.underlying_privacy_policy_url;
                    },
            
                'on_error': () => {
                    document.location = 'https://app.redchirp.com/app/public/legal';
                },
            });
      },
    },


    computed: {
        organization_label()
        {
            if ( this.organization_account == null ) return '';
            return this.organization_account.label;
        },

        organization_id()
        {
            if ( this.organization_account == null ) return '';
            return this.organization_account.organization_id;
        },

        tc_addendum_url()
        {
            return this.$router.resolve({
                'name': 'default-terms-and-conditions-addendum',
                'params' : {
                    'organization_id': this.$route.params.organization_id,
                }
            }).href;
        },
    },
}
</script>

<style lang="scss" scoped>
</style>